import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { initialState } from './initialState';

export const agentSlice = createSlice({
  name: 'agent',
  initialState,
  reducers: {
    setDimensions: (
      state,
      action: PayloadAction<{ width: number; height: number }>,
    ) => {
      state.width = action.payload.width;
      state.height = action.payload.height;
    },
    setHeaderHeight: (state, action: PayloadAction<number>) => {
      state.headerHeight = action.payload;
    },
  },
});

export const { actions: agentActions, reducer: agentReducer } = agentSlice;
